module.exports = __webpack_public_path__ + "img/icon-24-ic-stop.26c0a9c6.svg";